import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["renameForm"]

  showRename() {
    this.renameFormTarget.style.display = "flex"
  }

  hideRename() {
    this.renameFormTarget.style.display = "none"
  }
}
